import isString from '@dcode/is/string/string';
import isArray from '@dcode/is/array/array';

const style = document.createElement('div').style;

const prefixes = [
	'', 'Webkit', 'webkit', 'Moz', 'moz', 'MS', 'ms',
	'O', 'o', 'Khtml', 'khtml', 'Icab', 'icab'
];

const animations = {
	WebkitAnimation: 'webkitAnimationEnd',
	OAnimation: 'oAnimationEnd',
	msAnimation: 'MSAnimationEnd',
	animation: 'animationend'
};

const transitions = {
	WebkitTransition: 'webkitTransitionEnd',
	MozTransition: 'transitionend',
	OTransition: 'oTransitionEnd otransitionend',
	transition: 'transitionend'
};

const prefixed = (...rest) => {
	let context = rest[0];
	let property = rest[1];
	if (rest.length === 1) {
		property = context;
		context = style;
	}
	let id = -1;
	const camelProp = property[0].toUpperCase() + property.slice(1);
	while(++id < prefixes.length){
		const prefix = prefixes[id];
		const prop = prefix ? prefix + camelProp : property;
		if (prop in context) return prop;
	}
};

const animationEnd = animations[prefixed(animations, 'animation')];

const transitionEnd = transitions[prefixed(transitions, 'transition')];

const filter = (context, properties) => {
	for (let id = 0; id < properties.length; id += 1) {
		const prefixedProp = prefixed(context, properties[id]);
		if (prefixedProp) return prefixedProp;
	}
};

const Vendor = (context, prop) => {
	const method = isArray(prop) ? 'filter' : 'prefixed';
	return context[Vendor[method](context, prop)];
};

const hasClass = (element, className) => {
	if (element.classList) return !!className && element.classList.contains(className);
	return (` ${element.className.baseVal || element.className} `.indexOf(` ${className} `) !== -1);
};

const addClass = (element, className) => {
	if (element.classList) element.classList.add(className);
	else if (!hasClass(element, className)) {
		if (isString(element.className)) {
			element.className = `${element.className} ${className}`;
		} else {
			element.setAttribute('class', `${(element.className && element.className.baseVal) || ''} ${className}`);
		}
	}
};

const replaceClassName = (origClass, classToRemove) => {
  return origClass
    .replace(new RegExp(`(^|\\s)${classToRemove}(?:\\s|$)`, 'g'), '$1')
    .replace(/\s+/g, ' ')
		.replace(/^\s*|\s*$/g, '')
	;
};

const removeClass = (element, className) => {
	if (element.classList) {
		element.classList.remove(className)
	} else if (typeof element.className === 'string') {
		element.className = replaceClassName(
			element.className,
			className
		)
	} else {
		element.setAttribute('class', replaceClassName(
			(element.className && element.className.baseVal) || '',
			className
		));
	}
};

Vendor.style = style;
Vendor.prefixes = prefixes;
Vendor.prefixed = prefixed;
Vendor.animationEnd = animationEnd;
Vendor.transitionEnd = transitionEnd;
Vendor.filter = filter;
Vendor.hasClass = hasClass;
Vendor.addClass = addClass;
Vendor.removeClass = removeClass;
export default Vendor;
